import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import type {
  FiCatalogResponse,
  FiExecuteResponse,
  FiFocusArea,
  FiLimits,
  FiScopeRequest,
  FiSummarizeRequest,
  FiSummarizeResponse,
} from "@mapmycustomers/shared/types/entity/fieldInsight";
import type Organization from "@mapmycustomers/shared/types/Organization";

export const fetchFieldInsightsCharts = createAsyncAction(
  "@fieldInsights/fetchCharts/request",
  "@fieldInsights/fetchCharts/success",
  "@fieldInsights/fetchCharts/failure"
)<
  FiScopeRequest,
  { charts: FiCatalogResponse[]; organizationId: Organization["id"]; scope: FiScopeRequest },
  void
>();

export const fetchFieldInsightsFocusAreas = createAsyncAction(
  "@fieldInsights/fetchFocusAreas/request",
  "@fieldInsights/fetchFocusAreas/success",
  "@fieldInsights/fetchFocusAreas/failure"
)<void, { focusAreas: FiFocusArea[]; organizationId: Organization["id"] }, void>();

export const fetchFieldInsightsLimits = createAsyncAction(
  "@fieldInsights/fetchLimits/request",
  "@fieldInsights/fetchLimits/success",
  "@fieldInsights/fetchLimits/failure"
)<void, { limits: FiLimits; organizationId: Organization["id"] }, void>();

export const executeFieldInsightsChart = createAction("@fieldInsights/executeChart")<{
  callback: (response: FiExecuteResponse) => void;
  chartId: FiCatalogResponse["id"];
  failureCallback?: () => void;
  params: Record<string, unknown>;
  scope: FiScopeRequest;
}>();

export const removeFieldInsightsCharts = createAction("@fieldInsights/removeCharts")<
  FiCatalogResponse["id"][]
>();

export const summarizeFieldInsightsChart = createAction("@fieldInsights/summarizeChart")<{
  callback: (response: FiSummarizeResponse) => void;
  chartId: FiCatalogResponse["id"];
  failureCallback?: () => void;
  request: FiSummarizeRequest;
}>();

export type FieldInsightsActions = ActionType<
  | typeof executeFieldInsightsChart
  | typeof fetchFieldInsightsCharts
  | typeof fetchFieldInsightsFocusAreas
  | typeof fetchFieldInsightsLimits
  | typeof removeFieldInsightsCharts
  | typeof summarizeFieldInsightsChart
>;
